import React from 'react'
import {
  func, array, bool, object,
} from 'prop-types'
import { Checkbox } from '@cgtrader/triangle-ui/dist/src/ssr-index'

import FireIcon from 'images/icons/svg/FireIcon'

function CompetitionLevels({
  groupedTags,
  getLevelCheckboxState,
  onLevelSelect,
  selectedTags,
  isReadOnly,
  onTagSelect,
  limitTagCampaignsAndCostInflation,
}) {
  return (
    <div className="promote-modal__competition-levels">
      {Object.entries(groupedTags).reverse().map(([level, levelData]) => (
        <div key={level} className="promote-modal__competition-level">
          <div className="promote-modal__level-info">
            <Checkbox
              checkedColor="primary"
              id={`level-${level}`}
              label=""
              isChecked={getLevelCheckboxState(levelData.tags).checked}
              isIndeterminate={getLevelCheckboxState(levelData.tags).isIndeterminate}
              onChange={() => onLevelSelect(levelData.tags)}
              isDisabled={levelData.tags.length === 0 || isReadOnly}
              isControlled
              className="promote-modal__competition-checkbox"
            />
            <div className="promote-modal__level-details">
              <h4 className="promote-modal__level-name">{levelData.name}</h4>
              <p className="promote-modal__level-cost">{levelData.cost}</p>
            </div>
          </div>
          <div className="promote-modal__level-tags">
            {levelData.tags.length > 0 ? (
              levelData.tags.map(tagObj => {
                const isSelected = isReadOnly
                  ? tagObj.isSelected
                  : selectedTags.find(t => t.tag === tagObj.tag)
                const isDisabled = isReadOnly
                  ? true
                  : (!isSelected && selectedTags.length >= 20)

                return (
                  <div
                    key={tagObj.tag}
                    className={[
                      'promote-modal__tag-chip',
                      isSelected ? 'promote-modal__tag-chip--selected' : '',
                      isDisabled ? 'promote-modal__tag-chip--disabled' : '',
                      isReadOnly ? 'promote-modal__tag-chip--read-only' : '',
                    ].filter(Boolean).join(' ')}
                    onClick={() => !isDisabled && !isReadOnly && onTagSelect(tagObj)}
                    disabled={isDisabled}
                  >
                    {tagObj.tag}
                    {limitTagCampaignsAndCostInflation && tagObj.penalty > 0 && (
                      <FireIcon width={16} height={16} />
                    )}
                  </div>
                )
              })
            ) : (
              <span className="promote-modal__no-tags">No tags in this category</span>
            )}
          </div>
        </div>
      ))}
    </div>
  )
}

CompetitionLevels.propTypes = {
  groupedTags: object.isRequired,
  getLevelCheckboxState: func.isRequired,
  onLevelSelect: func.isRequired,
  selectedTags: array.isRequired,
  isReadOnly: bool.isRequired,
  onTagSelect: func.isRequired,
  limitTagCampaignsAndCostInflation: bool.isRequired,
}

export default CompetitionLevels
